import { render, staticRenderFns } from "./LoadingContainer.vue?vue&type=template&id=b7883ae8&scoped=true&"
import script from "./LoadingContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingContainer.vue?vue&type=style&index=0&id=b7883ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7883ae8",
  null
  
)

export default component.exports